import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    padding: "126px 24px 24px 138px",
  },
  container: {
    background: "#fff",
    padding: "24px",
    borderRadius: 10,
    border: "2px solid #e0e0e0",
  },
  searchField: {
    marginBottom: 24,
  },
  input: {
    padding: "12px 12px",
    fontSize: 16,
  },
  hint: {
    marginTop: 8,
    color: "#666",
  },
}));
